angular.module('unergie.main')
.controller('categoriesCtrl', ($scope, $location, $state, $filter, $stateParams, $timeout, DataAccess, ApiUser, DataAccessSearch, BoFeaturesService, AlertManager, DownloadService,
    AuthService, ModalService, TableGeneratorService, FilterMapping, FileUploader, OrganizationService, GovernmentPriceReductionPeriod, ErrorCatcher) => {
    const canChangeCategoryAccount = BoFeaturesService.isFeatureOn('canChangeCategoryAccount')
    const canMassEditCategories = BoFeaturesService.isFeatureOn('canMassEditCategories')
    $scope.crossOrg = BoFeaturesService.isFeatureOn('crossOrg')
    $scope.billingAdmin = BoFeaturesService.isFeatureOn('billingAdmin')
    $scope.billingSuperAdmin = BoFeaturesService.isFeatureOn('billingSuperAdmin')
    $scope.canBlockB2gAutoRun = BoFeaturesService.isFeatureOn('canBlockB2gAutoRun')
    $scope.canExportCategory = BoFeaturesService.isFeatureOn('canExportCategory')
    $scope.canEditReimbursementModality = BoFeaturesService.isFeatureOn('canEditReimbursementModality')
    $scope.canConfigureCategoryEmails = BoFeaturesService.isFeatureOn('canConfigureCategoryEmails')
    $scope.canChangePaymentFrequency = BoFeaturesService.isFeatureOn('canChangePaymentFrequency')
    $scope.canChangePaymentMode = BoFeaturesService.isFeatureOn('canChangePaymentMode')
    $scope.canSetGovernmentPriceReductions = BoFeaturesService.isFeatureOn('canSetGovernmentPriceReductions')
    $scope.showImportCategory = !BoFeaturesService.get('isEnvProd')
    $scope.contract_status_mapping = FilterMapping.contractStatus
    $scope.metaInvoiceTypes = FilterMapping.metaInvoiceTypes
    $scope.invoiceStatuses = [{ id: '50', title: 'Facturée' }, { id: '75', title: 'Extournée' }]
    $scope.canEditCategories = BoFeaturesService.isFeatureOn('canEditCategories')

    $scope.isB2B = OrganizationService.isB2B

    const canBiannual = (org) => BoFeaturesService.getModuleFeatures('b2gHome').canBiannual.split(',').includes(org || AuthService.getOrg())
    const canHalfGreenEnergy = (org) => BoFeaturesService.getModuleFeatures('b2gHome').canHalfGreenEnergy.split(',').includes(org || AuthService.getOrg())
    const canFiveStepsGreenEnergy = (org) => BoFeaturesService.getModuleFeatures('b2gHome').canFiveStepsGreenEnergy.split(',').includes(org || AuthService.getOrg())
    const isFactoring = (org) => BoFeaturesService.getModuleFeatures('b2gHome').isFactoring.split(',').includes(org || AuthService.getOrg())

    $scope.invoiceStatusesFilter = {
        50: 'Facturée',
        75: 'Extournée',
    }

    $scope.ibanStatusFilter = [
        { id: 'INITIAL', title: 'En cours de validation' },
        { id: 'VALIDATED', title: 'Validé' },
        { id: 'REJECTED', title: 'Rejeté' },
        { id: '<null>', title: 'Manquant' },
    ]
    $scope.nullableBooleanFilter = [{ id: 'true', title: 'Oui' }, { id: 'false', title: 'Non' }, { id: '<null>', title: 'NR' }]
    $scope.booleanFilter = [{ id: 'true', title: 'Oui' }, { id: 'false', title: 'Non' }]
    $scope.notNullFilter = [{ id: '!<null>', title: 'Oui' }, { id: '<null>', title: 'Non' }]

    $scope.energyTypeFilter = _.compact([
        { id: '0', title: $filter('billEnergyType')('0') },
        canFiveStepsGreenEnergy() ? { id: '25', title: $filter('billEnergyType')('25') } : undefined,
        (canHalfGreenEnergy() || canFiveStepsGreenEnergy()) ? { id: '50', title: $filter('billEnergyType')('50') } : undefined,
        canFiveStepsGreenEnergy() ? { id: '75', title: $filter('billEnergyType')('75') } : undefined,
        { id: '100', title: $filter('billEnergyType')('100') },
    ])
    $scope.paymentModeFilter = [
        { id: 'SEPA', title: $filter('billPaymentMode')('SEPA') },
        { id: isFactoring() ? 'FACTORING' : 'TRANSFER', title: $filter('billPaymentMode')('TRANSFER') },
    ]
    $scope.paymentFrequencyFilter = _.compact([
        { id: 'MONTHLY', title: $filter('billPaymentFrequency')('MONTHLY') },
        { id: 'BIMONTHLY', title: $filter('billPaymentFrequency')('BIMONTHLY') },
        canBiannual() ? { id: 'BIANNUAL', title: $filter('billPaymentFrequency')('BIANNUAL') } : undefined,
    ])

    $scope.categoryPayload = {}
    $scope.categoryTemplate = {
        name: { label: 'Libellé', required: true, type: 'text' },
        external_id: { label: 'Identifiant externe', type: 'text' },
        siret: { label: 'SIRET *', type: 'text', required: true, pattern: /^\d{14}$/ },
        legal_name: { label: 'Raison sociale', type: 'text' },
        business_line: { label: 'Secteur activité', type: 'text' },
        business_code: { label: 'NAF *', type: 'text', required: true, pattern: /^\d{4}[A-Z]$/ },
        se_code: { label: `Code SE (en l'absence de code SE, renseignez N/A)`, required: true, type: 'text' },
        ej_code: { label: `Code EJ (en l'absence de code EJ, renseignez N/A)`, required: true, type: 'text' },
        imputation_code: { label: 'Code d\'imputation', type: 'text' },
    }

    $scope.categoryTemplateCreate = _.assign({}, $scope.categoryTemplate, {
        energy_type: {
            label: `Type d'électricité *`,
            required: true,
            type: 'radio',
            enum: [
                { value: '0', label: $filter('billEnergyType')('0') },
                { value: '50', label: $filter('billEnergyType')('50') },
                { value: '100', label: $filter('billEnergyType')('100') },
            ],
        },
        payment_mode: {
            label: 'Modalité de paiement *',
            required: true,
            type: 'radio',
            enum: [
                { value: 'SEPA', label: $filter('billPaymentMode')('SEPA') },
                { value: isFactoring() ? 'FACTORING' : 'TRANSFER', label: $filter('billPaymentMode')('TRANSFER') },
            ],
        },
        payment_frequency: {
            label: 'Fréquence de facturation *',
            required: true,
            type: 'radio',
            enum: _.compact([
                { value: 'MONTHLY', label: $filter('billPaymentFrequency')('MONTHLY') },
                { value: 'BIMONTHLY', label: $filter('billPaymentFrequency')('BIMONTHLY') },
                canBiannual() ? { value: 'BIANNUAL', label: $filter('billPaymentFrequency')('BIANNUAL') } : undefined,
            ]),
        },
    })

    $scope.principalContactPayload = {}
    $scope.principalContactTemplate = {
        principal_civ: { label: 'Civilité *', required: true, type: 'select', enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }] },
        principal_givenname: { label: 'Prénom *', type: 'text', required: true },
        principal_sn: { label: 'NOM *', type: 'text', required: true },
        principal_mail: { label: 'E-mail', type: 'email', required: true },
        principal_phone: { label: 'Téléphone', type: 'phone-all', required: true },
    }

    $scope.contactPayload = {}
    $scope.contactTemplate = {
        civ: { label: 'Civilité *', required: true, type: 'select', enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }] },
        givenname: { label: 'Prénom *', type: 'text', required: true },
        sn: { label: 'NOM *', type: 'text', required: true },
        mail: { label: 'E-mail', type: 'emails', required: true },
        phone: { label: 'Téléphone', type: 'phone-all' },
    }

    $scope.secondaryContactPayload = {}
    $scope.secondaryContactTemplate = {
        secondary_civ: { label: 'Civilité *', required: true, type: 'select', enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }] },
        secondary_givenname: { label: 'Prénom *', type: 'text', required: true },
        secondary_sn: { label: 'NOM *', type: 'text', required: true },
        secondary_mail: { label: 'E-mail', type: 'emails' },
        secondary_phone: { label: 'Téléphone', type: 'phone-all' },
    }

    $scope.otherContactPayload = {}
    $scope.otherContactTemplate = {
        other_civ: { label: 'Civilité *', required: true, type: 'select', enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }] },
        other_givenname: { label: 'Prénom *', type: 'text', required: true },
        other_sn: { label: 'NOM *', type: 'text', required: true },
        other_mail: { label: 'E-mail', type: 'emails' },
        other_phone: { label: 'Téléphone', type: 'phone-all' },
    }

    $scope.addrPayload = {}
    $scope.addrTemplate = {
        addr_num_street: { label: 'Numéro et rue *', type: 'text' },
        addr_post_code: { label: 'Code postal *', type: 'text' },
        addr_city_lbl: { label: 'Ville *', type: 'text' },
        addr_bat: { label: 'Bâtiment', type: 'text' },
        addr_details: { label: 'Détails', type: 'text' },
        addr_locality: { label: 'Lieu dit', type: 'text' },
    }

    $scope.canSeeInvoiceDetails = () => AuthService.isMenuAccessible('metaInvoicesB2G')

    $scope.affectableAccount = []
    $scope.refreshAccounts = () => {
        DataAccess.myAffectations().$promise.then((affectations) => {
            $scope.affectedAccounts = affectations
            // empty affectableAccount without replacing
            $scope.affectableAccount.splice(0, $scope.affectableAccount.length)
            // put accounts back int affectableAccount
            _.each($scope.affectedAccounts, (a) => {
                $scope.affectableAccount.push({
                    value: a.id_account,
                    label: `${a.name}${$scope.crossOrg ? ` (${a.organization})` : ''}`,
                    organization: a.organization,
                })
            })
            const id_account = {
                label: 'Compte',
                required: true,
                type: 'select',
                hidden: (obj) => !(canChangeCategoryAccount || !obj.id),
                enum: $scope.affectableAccount,
            }
            $scope.categoryTemplate.id_account = id_account
            $scope.categoryTemplateCreate.id_account = id_account
            $scope.refresh()
        }).catch(ErrorCatcher)
    }
    $scope.refreshAccounts()

    $scope.categories = {
        refreshing: false,
        show: {},
        columns: _.omit({
            'selector': { label: 'Sélection', mode: 'filter_only' },
            'id': { label: 'ID', mode: 'search_operator', mandatory: true },
            'name': { label: 'Libellé', mode: 'search_wildcard', translateCsv: 'paquet_facturier' },
            'account.brand': { label: 'Compte', mode: 'search_wildcard', translateCsv: 'compte' },
            'account.customer_id': { label: 'ID compte', mode: 'hidden', csvIgnore: true, isVisible: false },
            'id_agreement_elec': { label: 'Marché élec', mode: 'search_wildcard', isVisible: false, mandatory: true },
            'id_agreement_gas': { label: 'Marché gaz', mode: 'hidden' },
            'external_id': { label: 'Identifiant externe', mode: 'search_wildcard', translateCsv: 'identifiant_externe' },
            'siret': { label: 'SIRET*', mode: 'search_wildcard' },
            'legal_name': { label: 'Raison sociale', mode: 'search_wildcard', translateCsv: 'raison_sociale' },
            'business_line': { label: 'Secteur activité', mode: 'search_wildcard', translateCsv: 'secteur' },
            'business_code': { label: 'NAF*', mode: 'search_wildcard', translateCsv: 'naf' },
            'se_code': { label: 'Code SE', mode: 'search_wildcard', translateCsv: 'code_se' },
            'ej_code': { label: 'Code EJ', mode: 'search_wildcard', translateCsv: 'code_ej' },
            'imputation_code': { label: 'Code d\'imputation', mode: 'search_wildcard', translateCsv: 'code_imputation' },
            'energy_type': { label: `Type d'énergie`, mode: 'search_strict', translateCsv: 'type_energie' },
            'payment_mode': { label: 'Mode paiement', mode: 'search_strict', translateCsv: 'modalite_paiement' },
            'payment_frequency': { label: 'Fréquence paiement', mode: 'search_strict', translateCsv: 'frequence_paiement' },

            'id_account': { label: 'id_account', mode: 'hidden' },
            'civ': { label: 'civ', mode: 'hidden', translateCsv: 'facturation_civilite' },
            'givenname': { label: 'givenname', mode: 'hidden', translateCsv: 'facturation_prenom' },
            'sn': { label: 'sn', mode: 'hidden', translateCsv: 'facturation_nom' },
            'phone': { label: 'phone', mode: 'hidden', translateCsv: 'facturation_telephone' },
            'mail': { label: 'mail', mode: 'hidden', translateCsv: 'facturation_email' },
            'addr_bat': { label: 'addr_bat', mode: 'hidden', translateCsv: 'adresse_batiment' },
            'addr_city_code': { label: 'addr_city_code', mode: 'hidden' },
            'addr_city_lbl': { label: 'addr_city_lbl', mode: 'hidden', translateCsv: 'adresse_ville' },
            'addr_details': { label: 'addr_details', mode: 'hidden', translateCsv: 'adresse_details' },
            'addr_locality': { label: 'addr_locality', mode: 'hidden' },
            'addr_num_street': { label: 'addr_num_street', mode: 'hidden', translateCsv: 'adresse_numero_rue' },
            'addr_post_code': { label: 'addr_post_code', mode: 'hidden', translateCsv: 'adresse_code_postal' },
            'secondary_civ': { label: 'civ', mode: 'hidden', translateCsv: 'secondaire_civilite' },
            'secondary_givenname': { label: 'givenname', mode: 'hidden', translateCsv: 'secondaire_prenom' },
            'secondary_sn': { label: 'sn', mode: 'hidden', translateCsv: 'secondaire_nom' },
            'secondary_phone': { label: 'phone', mode: 'hidden', translateCsv: 'secondaire_telephone' },
            'secondary_mail': { label: 'mail', mode: 'hidden', translateCsv: 'secondaire_email' },
            'other_civ': { label: 'civ', mode: 'hidden', translateCsv: 'autre_civilite' },
            'other_givenname': { label: 'givenname', mode: 'hidden', translateCsv: 'autre_prenom' },
            'other_sn': { label: 'sn', mode: 'hidden', translateCsv: 'autre_nom' },
            'other_phone': { label: 'phone', mode: 'hidden', translateCsv: 'autre_telephone' },
            'other_mail': { label: 'mail', mode: 'hidden', translateCsv: 'autre_email' },
            'principal_civ': { label: 'civ', mode: 'hidden', translateCsv: 'principal_civilite' },
            'principal_givenname': { label: 'givenname', mode: 'hidden', translateCsv: 'principal_prenom' },
            'principal_sn': { label: 'sn', mode: 'hidden', translateCsv: 'principal_nom' },
            'principal_phone': { label: 'phone', mode: 'hidden', translateCsv: 'principal_telephone' },
            'principal_mail': { label: 'mail', mode: 'hidden', translateCsv: 'principal_email' },
            'complete': { label: 'Complet', mode: 'search_strict', translateCsv: 'complet' },
            'do_not_send_email': { label: 'Email config', mode: 'hidden' },
            'block_auto_run': { label: 'Bloquage auto-run', mode: 'hidden' },
            'send_to_chorus': { label: 'Envoyer à CHORUS', mode: 'hidden' },
            'report_reimbursement': { label: 'Report des avoirs', mode: 'search_strict' },
            'billing_config': { label: 'Config. factu', mode: 'hidden' },
        }, canMassEditCategories ? [] : ['selector']),
        preventQueryParamsOverride: ['modal', 'action'],
    }

    if ($stateParams.customer_id) {
        // if customer_id in params, we force the display of the column
        $scope.categories.columns['account.customer_id'].forceVisible = true
    }

    if ($stateParams.brand || $stateParams.name || $stateParams.complete || $stateParams.siret || $stateParams.id || $stateParams.customer_id) {
        $scope.categories.instance = {
            reload: () => {},
            page: () => 1,
            count: () => 25,
            sorting: () => ({}),
            filter: () => _.assign(_.clone($location.search()), _.pickBy({
                'account.brand': $stateParams.brand,
                'name': $stateParams.name,
                'complete': $stateParams.complete,
                'siret': $stateParams.siret,
                'id': $stateParams.id,
                'account.customer_id': $stateParams.customer_id,
            })),
        }
    }

    const pdlColumns = {
        'selector': { label: 'Selection', mode: 'filter_only' },
        'id': { label: 'Id', mode: 'search_wildcard', length: 9 },
        'account.brand': { label: 'Compte', mode: 'search_wildcard' },
        'id_prm': { label: 'PRM', mode: 'search_wildcard', length: 14 },
        'label': { label: 'Libellé', mode: 'search_wildcard' },
        'category.name': { label: 'Catégorie', mode: 'search_wildcard' },
        'status': { label: 'Statut', mode: 'search_operator', binding: 'technical_status' },
        'technical_status': { label: 'Statut', mode: 'hidden', hidden_search: 'search_operator' },
        'max_power': { label: 'Puissance', mode: 'search_operator' },
        'id_p_calendar': { label: 'Offre', mode: 'search_wildcard' },
        'prm.addr_num_street': { label: 'Adresse', mode: 'search_wildcard' },
        'prm.addr_post_code': { label: 'Code postal', mode: 'search_wildcard' },
        'prm.metter_kind': { label: 'Type Compteur', mode: 'search_wildcard' },
        'prm.metter_number': { label: 'Matricule', mode: 'search_wildcard' },
        'commissioning_date': { label: 'Date activation', mode: 'search_date' },
        'decommissioning_date': { label: 'Date résiliation', mode: 'search_date' },
        'id_account': { label: 'Id_account', mode: 'hidden' },
        'prm.distributor_it': { label: 'Matricule', mode: 'hidden' },
        'account.organization': { label: 'Organisation', mode: 'hidden' },
        'subscription_type': { label: 'Type souscription', mode: 'search_wildcard' },
    }

    const metaInvoicesColumns = {
        id: { label: 'ID', mode: 'search_operator' },
        pdf_path: { label: 'PDF', mode: 'search_wildcard' },
        pdf_fees_path: { label: 'PDF Frais', mode: 'search_wildcard' },
        xlsx_path: { label: 'XLSX', mode: 'search_wildcard' },
        zip_path: { label: 'ZIP', mode: 'search_wildcard' },
        invoice_number: { label: 'N° Facture', mode: 'search_wildcard' },
        type: { label: 'Type', mode: 'search_wildcard' },
        status: { label: 'Status', mode: 'search_operator' },
        invoice_date: { label: 'Date Facture', mode: 'search_date' },
        period_start_date: { label: 'Début', mode: 'search_date' },
        period_end_date: { label: 'Fin', mode: 'search_date' },
        total: { label: 'Total', mode: 'search_operator' },
        total_cons_valued: { label: 'Consommation', mode: 'search_operator' },
        total_taxes: { label: 'Taxe', mode: 'search_operator' },
        total_vat: { label: 'TVA', mode: 'search_operator' },
        preparation_result: { label: 'Résultats intermédiaires', mode: 'hidden' },
        reversal_of: { label: 'Extourne', mode: 'hidden' },
        error_code: { label: 'Code erreur', mode: 'hidden' },
        external_status: { label: 'Statut Chorus', mode: 'search_wildcard' },
    }

    if ($scope.crossOrg) {
        $scope.categories.columns.organization = { label: 'Organisation', mode: 'search_wildcard', csvIgnore: true }
        $scope.categories.columns['org.type'] = { label: `Type d'organisation`, mode: 'search_wildcard', csvIgnore: true }
        $scope.categories.columns['account.customer_id'].mode = 'search_wildcard'
    }

    if ($scope.canEditReimbursementModality) {
        $scope.categories.columns.iban_status = { label: 'Statut de validation IBAN', mode: 'search_wildcard' }
        $scope.categories.columns.iban = { label: 'IBAN', mode: 'hidden' }
    }

    const doneFetchingCategories = (categories) => {
        _.each(categories, (cat) => {
            _.each(['b2g_invoice'], (template) => {
                cat[`send_${template}`] = !cat.do_not_send_email || !cat.do_not_send_email.includes(`#${template}#`)
            })
        })
        if ($stateParams.name) {
            $timeout(() => {
                const cat = _.find($scope.categories.instance.data, { name: $stateParams.name })
                if (cat) {
                    $scope.toggleExpand(cat)
                    cat.activeTabIndex = 2 // Factures
                }
            })
        }
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.categories, 'vw-ref-contract-category', 'account.org,governmentPriceReductionPeriods', doneFetchingCategories, {
        orderBy: 'name',
    })

    $scope.refreshCategoryData = function (c) {
        return DataAccessSearch({
            columns: _.filter(_.map($scope.categories.show, (value, key) => key), (value) => value !== 'selector'),
        }).searchPaginated({ resource: 'vw-ref-contract-category', id: c.id, withRelated: 'account.org,governmentPriceReductionPeriods' }).$promise
        .then((result) => _.assign(c, result.results[0]))
        .catch(ErrorCatcher)
    }

    $scope.prepareCategoryPayload = (c) => {
        _.assign($scope.categoryPayload, _.pick(c, ['id', 'id_account', 'name', 'external_id', 'siret', 'legal_name', 'business_line', 'business_code', 'se_code', 'ej_code', 'imputation_code']))
    }

    $scope.prepareContactPayload = (c) => {
        _.assign($scope.contactPayload, _.pick(c, ['civ', 'givenname', 'sn', 'mail', 'phone']))
    }

    $scope.prepareSecondaryContactPayload = (c) => {
        _.assign($scope.secondaryContactPayload, _.pick(c, ['secondary_civ', 'secondary_givenname', 'secondary_sn', 'secondary_mail', 'secondary_phone']))
    }

    $scope.preparePrincipalContactPayload = (c) => {
        _.assign($scope.principalContactPayload, _.pick(c, ['principal_civ', 'principal_givenname', 'principal_sn', 'principal_mail', 'principal_phone']))
    }

    $scope.prepareOtherContactPayload = (c) => {
        _.assign($scope.otherContactPayload, _.pick(c, ['other_civ', 'other_givenname', 'other_sn', 'other_mail', 'other_phone']))
    }

    $scope.prepareAddrPayload = (c) => {
        _.assign($scope.addrPayload, _.pick(c, ['addr_num_street', 'addr_post_code', 'addr_city_lbl', 'addr_details', 'addr_locality', 'addr_bat']))
    }

    $scope.prepareNew = () => {
        $scope.categoryPayload = {
            id: undefined,
            id_account: undefined,
            name: undefined,
            external_id: undefined,
            siret: undefined,
            legal_name: undefined,
            business_line: undefined,
            business_code: undefined,
            se_code: undefined,
            ej_code: undefined,
            imputation_code: undefined,
        }
    }

    $scope.updateCategory = (c, payload) => {
        c.modifying = true
        if (payload.payment_mode === 'SEPA') {
            payload.report_reimbursement = false
        }
        delete payload.id
        return DataAccess.updateRefContractCategory({ id: c.id }, payload).$promise.then(() => {
            AlertManager.success('Paquet facturier mis à jour')
            $scope.refreshCategoryData(c)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            c.modifying = false
        })
    }

    $scope.updateCategoryBillingConfig = (c, payload) => {
        return $scope.updateCategory(c, { billing_config: _.assign({}, c.billing_config, payload) })
    }

    $scope.massEditCategory = () => {
        const categories = $scope.getSelectedCategories()
        const template = $scope.massEditCategoryTemplate
        if (!categories.length) {
            return
        }
        $scope.massEditCategoryRunning = true
        const payload = {
            categoryIds: _.map(categories, (c) => c.id),
            updates: template,
        }
        return DataAccess.massEditCategory(payload).$promise.then(() => {
            AlertManager.success('Paquets facturiers mis à jour')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massEditCategoryRunning = false
        })
    }

    $scope.massEditCategoryFields = {
        overrideEJ: { label: 'Modifier le code EJ', type: 'checkbox' },
        ej_code: { hidden: (t) => !t.overrideEJ, label: `Code EJ`, type: 'text' },
        overrideSE: { label: 'Modifier le code SE', type: 'checkbox' },
        se_code: { hidden: (t) => !t.overrideSE, label: `Code SE`, type: 'text' },
        overridePrimaryContact: { label: 'Modifier le contact principal', type: 'checkbox' },
        principal_civ: { hidden: (t) => !t.overridePrimaryContact, label: 'Civilité*', type: 'select', enum: [{ label: 'M.', value: 'M.' }, { label: 'Mme', value: 'Mme' }], required: true },
        principal_givenname: { hidden: (t) => !t.overridePrimaryContact, label: 'Prénom*', type: 'text', required: true },
        principal_sn: { hidden: (t) => !t.overridePrimaryContact, label: 'Nom*', type: 'text', required: true },
        principal_role: { hidden: (t) => !t.overridePrimaryContact, label: 'Rôle', type: 'text' },
        principal_phone: { hidden: (t) => !t.overridePrimaryContact, label: 'Téléphone*', type: 'phone-all', required: true },
        principal_mail: { hidden: (t) => !t.overridePrimaryContact, label: 'E-mail*', type: 'emails', required: true },
        overrideBillingContact: { label: 'Modifier le contact de facturation', type: 'checkbox' },
        civ: { hidden: (t) => !t.overrideBillingContact, label: 'Civilité*', type: 'select', enum: [{ label: 'M.', value: 'M.' }, { label: 'Mme', value: 'Mme' }], required: true },
        givenname: { hidden: (t) => !t.overrideBillingContact, label: 'Prénom*', type: 'text', required: true },
        sn: { hidden: (t) => !t.overrideBillingContact, label: 'Nom*', type: 'text', required: true },
        role: { hidden: (t) => !t.overrideBillingContact, label: 'Rôle', type: 'text' },
        phone: { hidden: (t) => !t.overrideBillingContact, label: 'Téléphone*', type: 'phone-all', required: true },
        mail: { hidden: (t) => !t.overrideBillingContact, label: 'E-mail*', type: 'emails', required: true },
    }

    $scope.massEditCategoryTemplate = {
        overrideEJ: false,
        overrideSE: false,
        overridePrimaryContact: false,
        overrideBillingContact: false,
    }

    $scope.toggleExpand = (c) => {
        if (c) {
            c.expanded = !c.expanded
        }
        if (c.expanded) {
            c.energyTypeFilter = _.compact([
                { id: '0', title: $filter('billEnergyType')('0') },
                canFiveStepsGreenEnergy(c.organization) ? { id: '25', title: $filter('billEnergyType')('25') } : undefined,
                (canHalfGreenEnergy(c.organization) || canFiveStepsGreenEnergy(c.organization)) ? { id: '50', title: $filter('billEnergyType')('50') } : undefined,
                canFiveStepsGreenEnergy(c.organization) ? { id: '75', title: $filter('billEnergyType')('75') } : undefined,
                { id: '100', title: $filter('billEnergyType')('100') },
            ])
            c.paymentModeFilter = [
                { id: 'SEPA', title: $filter('billPaymentMode')('SEPA') },
                { id: isFactoring(c.organization) ? 'FACTORING' : 'TRANSFER', title: $filter('billPaymentMode')('TRANSFER') },
            ]
            c.paymentFrequencyFilter = _.compact([
                { id: 'MONTHLY', title: $filter('billPaymentFrequency')('MONTHLY') },
                { id: 'BIMONTHLY', title: $filter('billPaymentFrequency')('BIMONTHLY') },
                canBiannual(c.organization) ? { id: 'BIANNUAL', title: $filter('billPaymentFrequency')('BIANNUAL') } : undefined,
            ])
        }
    }

    $scope.toggleSelected = function (c, e) {
        e.preventDefault()
        e.stopPropagation()
        c.selected = !c.selected
    }

    $scope.selectAll = () =>
        _.forEach($scope.categories.instance.data, (c) => {
            c.selected = true
        })


    $scope.deselectAll = () =>
        _.forEach($scope.categories.instance.data, (c) => {
            c.selected = false
            return true
        })

    $scope.getSelectedCategories = () => _.filter($scope.categories.instance.data, (c) => c.selected)

    $scope.getSelectedNumber = () => _.countBy(_.get($scope, 'categories.instance.data', []), 'selected').true || 0

    $scope.importCategory = function () {
        if ($scope.importCategoryPayload.category.queue.length > 0) {
            const file = $scope.importCategoryPayload.category.queue[0]
            const params = {
                ignore_invoices: !!($scope.importCategoryPayload.ignore_invoices),
                accountId: $scope.importCategoryPayload.accountId,
            }
            if ($scope.importCategoryPayload.shift) {
                params.shift = $scope.importCategoryPayload.shift
                params.shiftUnit = $scope.importCategoryPayload.shiftUnit || 'day'
            }
            if ($scope.importCategoryPayload.mapOffers) {
                params.mapOffers = $scope.importCategoryPayload.mapOffers
            }
            file.formData.push(params)
            return $scope.importCategoryPayload.category.uploadAll()
        }
    }

    // IMPORT category
    $scope.importCategoryFields = {
        accountId: {
            label: 'Account',
            type: 'select',
            enum: $scope.affectableAccount,
            required: true,
        },
        category: {
            label: 'Fichier',
            type: 'file',
            accept: '.zip',
        },
        ignore_invoices: {
            label: 'Ignorer les factures',
            type: 'checkbox',
        },
        shift: {
            label: 'Décalage',
            type: 'number',
        },
        shiftUnit: {
            label: 'Unité',
            type: 'select',
            enum: [
                { label: 'jour(s)', value: 'day' },
                { label: 'mois', value: 'month' },
                { label: 'année(s)', value: 'year' },
            ],
        },
        mapOffers: {
            label: 'Migrer offres en',
            type: 'select',
            enum: [
                { label: '-', value: false },
                { label: 'paris', value: 'PARIS' },
                { label: 'sipperec', value: 'SIPPEREC' },
                { label: 'sieil (bat)', value: 'SIEIL_BAT' },
                { label: 'sieil (ep)', value: 'SIEIL_EP' },
                { label: 'smed13 (bat)', value: 'SMED13_BAT' },
                { label: 'smed13 (ep)', value: 'SMED13_EP' },
                { label: 'annecy (bat)', value: 'ANNECY_BAT' },
                { label: 'annecy (ep)', value: 'ANNECY_EP' },
                { label: 'sieeen (bat)', value: 'SIEEEN_BAT' },
                { label: 'sieeen (ep)', value: 'SIEEEN_EP' },
                { label: 'syane (bat)', value: 'SYANE_BAT' },
                { label: 'syane (ep)', value: 'SYANE_EP' },
                { label: 'sdeeg (bat)', value: 'SDEEG_BAT' },
                { label: 'sdeeg (ep)', value: 'SDEEG_EP' },
            ],
        },
    }
    $scope.importCategoryPayload = {
        shiftUnit: 'month',
        mapOffers: false,
        category: new FileUploader({
            url: '/api-admin/import/category',
            alias: 'file',
            formData: [],
            autoUpload: false,
            removeAfterUpload: true,
            method: 'POST',
            onSuccessItem(item, response, status, headers) {
                AlertManager.success(`Categorie importée: ${response.id}`)
            },
            onErrorItem(item, response, status, headers) {
                return ErrorCatcher({ data: response })
            },
            onBeforeUploadItem(item) {
            },
        }),
    }

    const doneFetchingPdls = (c) => () => {
        c.pdls.fetched = true
    }

    $scope.getPdlForCategory = (c) => {
        c.pdls = {
            columns: _.clone(pdlColumns),
            preventAddressBar: true,
        }
        return TableGeneratorService.getTable(c.pdls, 'pdls', 'prm', doneFetchingPdls(c), { search: { id_category: c.id } })
    }

    $scope.fetchPdlForCategory = (c) => {
        if (!c.pdls || (!c.pdls.fetched && !c.pdls.refreshing)) {
            $scope.getPdlForCategory(c)
        }
    }

    const doneFetchingInvoices = (c) => () => {
        c.invoices.fetched = true
    }

    $scope.getInvoicesForCategory = (c) => {
        c.invoices = {
            columns: _.clone(metaInvoicesColumns),
            preventAddressBar: true,
        }
        return TableGeneratorService.getTable(c.invoices, 'meta-invoices-light', undefined, doneFetchingInvoices(c), {
            search: { id_category: c.id },
            in: ['status=50,75'],
        })
    }

    $scope.fetchInvoicesForCategory = (c) => {
        if (!c.invoices || (!c.invoices.fetched && !c.invoices.refreshing)) {
            $scope.getInvoicesForCategory(c)
        }
    }

    $scope.dl = (invoice, id_account, type) => {
        return DownloadService.downloadInvoice(invoice[`${type}_path`], id_account)
    }

    $scope.isActive = (state) => $state.is(state)

    if ($stateParams.action && $stateParams.action === 'new') {
        $timeout(() => {
            const newCat = document.getElementById('newcat')
            newCat.click()
        })
    }

    $scope.updateSendMail = (c, template) => {
        c.modifyingMailConf = true
        return DataAccess.updateRefContractCategoryMailConf({ id: c.id }, { [template]: c[`send_${template}`] }).$promise.then(() => {
            AlertManager.success('Configuration mise à jour')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            c.modifyingMailConf = false
        })
    }

    $scope.openBankDetailsModal = (category, value) => {
        if (['VALIDATED', 'INITIAL'].includes(category.iban_status) && value != null) {
            return $scope.updateCategory(category, { report_reimbursement: value })
        }
        ModalService.openModal({ type: 'bankDetailsModal', size: 'lg', backdrop: 'static' },
            { category, value: (value != null ? value : category.report_reimbursement), orgType: category.account.org.type },
            (result) => {
                if (result && result.report_reimbursement != null) {
                    $scope.updateCategory(category, { report_reimbursement: result.report_reimbursement })
                }
            })
    }

    $scope.openEditCategoryModal = (c, newOne) => {
        let category = c
        if (category) {
            category = _.omit(category, [
                'energyTypeFilter',
                'paymentModeFilter',
                'paymentFrequencyFilter',
                'account',
                'brand',
                'complete',
                'pdls',
                'invoices',
                'modifying',
                'modifyingMailConf',
                'expanded',
                'send_b2g_invoice',
                '$$hashKey',
                'activeTabIndex',
                'customer_id',
                'selector',
            ])
        }
        if (newOne) {
            category = _.omit(category, ['id', 'name', 'status', 'iban_status', 'iban'])
        }
        ModalService.openModal({ type: 'editCategoryModal', size: 'xlg', backdrop: 'static' }, { category, id_account: null }, () => {
            $scope.refresh()
        })
    }

    $scope.openNewManagedAccountModal = () => {
        ModalService.openModal({ type: 'newManagedAccountModal', size: 'lg', backdrop: 'static' })
    }

    $scope.governmentPriceReductionsFields = {
        type: {
            label: `Type de dispositif`,
            type: 'select',
            enum: [{ value: 'tariff-shield', label: `Bouclier tarifaire` }, { value: 'shock-absorber', label: `Amortisseur électricité` }],
            required: true,
            onSelect: (value) => {
                switch (value) {
                    case 'shock-absorber':
                        $scope.governmentPriceReductionsTemplate.valid_from = '2023-01-01'
                        $scope.governmentPriceReductionsTemplate.valid_to = '2023-12-31'
                        break
                    case 'tariff-shield':
                        $scope.governmentPriceReductionsTemplate.valid_from = '2023-02-01'
                        $scope.governmentPriceReductionsTemplate.valid_to = '2024-01-31'
                        break
                  // 'collective-tariff-shield'
                }
            },
        },
        valid_from: {
            label: 'Début',
            type: 'date',
            required: true,
        },
        valid_to: {
            label: 'Fin',
            type: 'date',
            required: true,
        },
        unit_price: {
            label: 'Montant par kWh',
            type: 'number',
            min: 0,
            required: true,
        },
    }

    $scope.governmentPriceReductionsTemplate = {}

    $scope.updateGovernmentPriceReductionsTemplate = (gpr) => {
        if (!gpr) {
            $scope.governmentPriceReductionsTemplate.type = null
            $scope.governmentPriceReductionsTemplate.unit_price = null
            $scope.governmentPriceReductionsTemplate.valid_from = null
            $scope.governmentPriceReductionsTemplate.valid_to = null
        } else {
            $scope.governmentPriceReductionsTemplate.type = gpr.type
            $scope.governmentPriceReductionsTemplate.unit_price = gpr.unit_price
            $scope.governmentPriceReductionsTemplate.valid_from = gpr.valid_from
            $scope.governmentPriceReductionsTemplate.valid_to = gpr.valid_to
        }
    }

    $scope.updateGovernmentPriceReductions = (category, gpr, update) => {
        GovernmentPriceReductionPeriod.updateCategoryGovernmentPriceReductionPeriod({
            idPeriod: gpr.id,
        }, {
            unit_price: update.unit_price,
            valid_from: update.valid_from, // was '2023-01-01'
            valid_to: update.valid_to, // was'2023-12-31',
            type: update.type,
        }).$promise.then((result) => {
            gpr.unit_price = update.unit_price
            gpr.valid_from = update.valid_from
            gpr.valid_to = update.valid_to
            gpr.type = update.type
            AlertManager.success('Dispositif mis à jour')
        }).catch(ErrorCatcher)
    }


    $scope.addGovernmentPriceReductions = (category, update) => {
        GovernmentPriceReductionPeriod.addCategoryGovernmentPriceReductionPeriod({
        }, {
            id_category: category.id,
            unit_price: update.unit_price,
            valid_from: update.valid_from, // was '2023-01-01'
            valid_to: update.valid_to, // was'2023-12-31',
            type: update.type,
        }).$promise.then((result) => {
            category.governmentPriceReductionPeriods.push(result)
            AlertManager.success('Dispositif ajouté')
        }).catch(ErrorCatcher)
    }

    $scope.deleteGovernmentPriceReductions = (category, gpr) => {
        GovernmentPriceReductionPeriod.deleteCategoryGovernmentPriceReductionPeriod({
            idPeriod: gpr.id,
        }).$promise.then((result) => {
            const idx = category.governmentPriceReductionPeriods.findIndex((period) => period.id === gpr.id)
            category.governmentPriceReductionPeriods.splice(idx, 1)
            AlertManager.success('Dispositif supprimé')
        }).catch(ErrorCatcher)
    }

    if ($stateParams.modal) {
        $scope.openEditCategoryModal()
    }
})
